import React from "react";
import "../../styles/loading-spinner.css";
const Error = _ref => {
    let { errorMessage = "Ein Fehler ist aufgetreten", children } = _ref;
    return /*#__PURE__*/ React.createElement("div", {
        className: "w-1/3 justify-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-center text-xl lg:text-2xl"
    }, errorMessage), children);
};
export default Error;
